module.exports = __webpack_public_path__ + "static/media/ExclamationIcon.689d60ff.svg";